module.exports = __webpack_public_path__ + "img/next_q_btn_after.a1c180a7.png";